var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocateItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.283,
    height: 20.29,
    viewBox: "0 0 25.283 20.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#479ed5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.933 -4505.094)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-353.873,4522.631a1.354,1.354,0,0,1-1.351,1.353h-4.257v1.4h4.257a2.755,2.755,0,0,0,2.751-2.753v-4.257h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-353.873,4507.847v4.257h1.4v-4.257a2.755,2.755,0,0,0-2.751-2.753h-4.257v1.4h4.257A1.354,1.354,0,0,1-353.873,4507.847Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.532,4507.847a1.354,1.354,0,0,1,1.351-1.353h4.257v-1.4h-4.257a2.756,2.756,0,0,0-2.752,2.753v4.257h1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.532,4522.631v-4.257h-1.4v4.257a2.756,2.756,0,0,0,2.752,2.753h4.257v-1.4h-4.257A1.354,1.354,0,0,1-370.532,4522.631Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-346.85,4515.024l-3.167-3.167a.7.7,0,0,0-.989,0h0a.7.7,0,0,0-.205.5.7.7,0,0,0,.205.5l1.989,1.989h-7.03a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.7h7.03l-1.989,1.988a.7.7,0,0,0-.205.5.7.7,0,0,0,.205.5.7.7,0,0,0,.99-.008h0l3.167-3.167a.7.7,0,0,0,.2-.512A.691.691,0,0,0-346.85,4515.024Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.12,0H5.852A1.121,1.121,0,0,1,6.973,1.121V5.853a1.12,1.12,0,0,1-1.12,1.12H1.12A1.12,1.12,0,0,1,0,5.853V1.12A1.12,1.12,0,0,1,1.12,0Z",
    transform: "translate(-365.586 4511.753)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocateItem);
export default __webpack_public_path__ + "static/media/unlocateItem.ad7d6adad6e3469fb4cf4734eba0e59c.svg";
export { ForwardRef as ReactComponent };